import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { itemBasedSalesReportRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.STORE_EMPLOYEE];

const itemBasedSalesReportRouteMetadata: IRouteMetadataObj<
  typeof itemBasedSalesReportRoutesObj
> = {
  list: {
    title: "seller.salesReport.index.title",
    description: "empty",
    lazy: () => import("@pages/reportManagement/itemBasedSalesReport/page"),
    mode: "index",
    type: "main",
    icon: "FileChartLine",
    breadcrumbs: [],
    permission,
  },
};

export const itemBasedSalesReportRoutes = createRoute<
  typeof itemBasedSalesReportRoutesObj
>(itemBasedSalesReportRoutesObj, itemBasedSalesReportRouteMetadata);
